import { render, staticRenderFns } from "./ProductSalesDetailTable.vue?vue&type=template&id=998ab792&"
import script from "./ProductSalesDetailTable.vue?vue&type=script&lang=js&"
export * from "./ProductSalesDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports